export enum WpEndpoint {
  Posts = '/posts',
  Users = '/users',
}

export enum WcStoreEndpoint {
  Products = '/products',
  OrderDetails = '/orders',
  CreateCustomer = '/customers',
  CustomerDetails = '/customers',
  Cart = '/cart',
  Categories = '/products/categories',
  Locations = '/shipping/zones/:zoneId/locations',
  UpdateCustomer = '/cart/update-customer',
}

export enum WcRestEndpoint {
  Products = '/products',
  Categories = '/products/categories',
  Tags = '/products/tags',
  Orders = '/orders',
}

export enum FetchCoreEndpoint {
  Delivery = '/delivery',
  PostCodes = '/api/store/postcodes',
  Base = '/',
}

export interface WcQueryParams {
  page?: number
  searchTerm?: string
  filters?: Record<string, unknown[]>
  perPage?: number
  orderBy?: string
  order?: 'asc' | 'dsc'
}

export interface WcParams {
  page?: number
  per_page?: number
  search?: string
  orderby?: string
  order?: 'asc' | 'dsc'
  [string: string]: unknown
}
